<template>
  <section>
    <editar-usuario />
    <GestionarCuenta />
    <h3 class="primary--text"><v-icon info>group</v-icon>Usuarios</h3>
    <v-card>
      <v-card-text>
        <v-layout>
          <v-tooltip bottom>
            <v-btn
              class="btn-refresh"
              icon
              slot="activator"
              @click="
                v => {
                  filterShow = filterShow ? false : true;
                }
              "
            >
              <v-icon>filter_list</v-icon>
            </v-btn>
            <span>Filtros</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              @click.native="listarUsuarios()"
              class="btn-refresh"
              slot="activator"
              ><v-icon>refresh</v-icon>
            </v-btn>
            <span>{{ $t("common.updateList") }}</span>
          </v-tooltip>
        </v-layout>
        <!-- Filtros-->
        <v-flex xs12>
          <transition name="slide-fade">
            <div class="filter-container-rrhh" v-show="filterShow">
              <v-icon small color="primary">search</v-icon>
              <div class="filter-item">
                <v-text-field
                  label="Usuario"
                  @input="filterUsuario"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Nombre completo"
                  @input="filterNombreCompleto"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Correo"
                  @input="filterCorreo"
                ></v-text-field>
              </div>
              <!-- botones cerrar -->
              <div class="btn-filter">
                <v-tooltip bottom>
                  <v-btn icon small slot="activator" @click.native="recargar()">
                    <v-icon small>refresh</v-icon>
                  </v-btn>
                  <span>Recargar filtros</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    slot="activator"
                    @click.native="
                      () => {
                        filterShow = false;
                      }
                    "
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                  <span>Cerrar filtros</span>
                </v-tooltip>
              </div>
            </div>
          </transition>
        </v-flex>
        <v-flex xs12 v-if="lista_usuarios.length > 0">
          <v-data-table
            class="elevation-1 tabla-comprimida-light"
            :headers="headers"
            :items="lista_usuarios"
            item-key="id"
            :search="filters"
            :custom-filter="customFilter"
            no-data-text="Sin datos"
          >
            <template slot="items" slot-scope="items">
              <td class="text-xs-center">{{ items.item.nombre_usuario }}</td>
              <td class="text-xs-center">
                {{ items.item.nombre_completo }}
              </td>
              <td class="text-xs-center">{{ items.item.correo }}</td>
              <td>
                <ul>
                  <li v-for="rol in items.item.roles" :key="rol.id">
                    {{ rol.descripcion }}
                  </li>
                </ul>
              </td>
              <td title="Activar/Desactivar usuario">
                <v-switch
                  value
                  :input-value="items.item.id_estado === 1 ? true : false"
                  @change="cambiarEstado(items.item)"
                ></v-switch>
              </td>
              <td>
                <v-chip
                  label
                  color="success"
                  text-color="white"
                  v-if="items.item.id_estado === 1"
                >
                  {{ items.item.estado.descripcion }}
                </v-chip>
                <v-chip
                  label
                  color="error"
                  text-color="white"
                  v-if="items.item.id_estado === 2"
                >
                  {{ items.item.estado.descripcion }}
                </v-chip>
              </td>
              <td class="nowrap">
                <v-tooltip bottom>
                  <v-btn
                    icon
                    slot="activator"
                    outline
                    color="primary"
                    @click="editarUsuario(items.item)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <span>Editar registro</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    slot="activator"
                    outline
                    color="primary"
                    @click="gestionarCuenta(items.item)"
                  >
                    <v-icon>person</v-icon>
                  </v-btn>
                  <span>Gestionar cuenta</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import EditarUsuario from "./dialogs/EditarUsuario.vue";
import GestionarCuenta from "./dialogs/GestionarCuenta.vue";
export default {
  mixins: [],
  components: {
    EditarUsuario,
    GestionarCuenta
  },
  async mounted() {
    await this.listarUsuarios();
    this.$bus.$on("closeDialogEditUsuarioRoles", async () => {
      await this.listarUsuarios();
      await this.listarUsuarios();
    });
    this.$bus.$on("closeDialogGestionarCuenta", async () => {
      await this.listarUsuarios();
      await this.listarUsuarios();
    });
  },
  data() {
    return {
      //Filtros
      // -------------------------
      filterShow: true,
      filters: {
        nombre_usuario: "",
        nombre_completo: "",
        correo: ""
      },
      //--------------------------
      lista_usuarios: [],
      headers: [
        {
          text: this.$t("user.crud.user"),
          value: "nombre_usuario",
          align: "center"
        },
        {
          text: this.$t("user.crud.fullname"),
          value: "nombre_completo",
          align: "center",
          sortable: false
        },
        { text: this.$t("user.crud.email"), value: "correo", align: "center" },
        { text: "Roles", value: "roles", sortable: false },
        { text: this.$t("common.active"), sortable: false, align: "center" },
        {
          text: this.$t("user.crud.status"),
          value: "id_estado",
          align: "center"
        },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      form: {
        usuario: "",
        contrasena: "",
        email: "",
        id_entidad: null,
        id_rol: null
      },
      valid: true,
      active: []
    };
  },
  methods: {
    editarUsuario(item) {
      this.$bus.$emit("openDialogEditarUsuario", item);
    },
    gestionarCuenta(item) {
      this.$bus.$emit("openDialogGestionarCuenta", item);
    },
    async listarUsuarios() {
      try {
        let res = await this.$service.graphql({
          query: `
          query{
            vUsuarioGenerals{
              rows{
                id
                nombre_usuario
                correo
                id_estado
                nro_intentos
                bloqueo
                fecha_bloqueo
                ip_bloqueo
                fecha_ultimo_intento
                foto
                nombre_unidad
                cargo
                puesto
                dependencia
                personas
                estado
                roles
              }
            }
          }
        `
        });
        this.lista_usuarios = [];
        let l_tmp = res.vUsuarioGenerals.rows;
        l_tmp.forEach(element => {
          // Damos formato al estado
          element.estado = element.estado[0];
          if (element.personas.length > 0) {
            element.nombre_completo = `${element.personas[0].nombres} ${element.personas[0].ap_paterno} ${element.personas[0].ap_materno}`;
          } else {
            element.nombre_completo = "Sin datos personales";
          }
        });
        this.lista_usuarios = l_tmp;
      } catch (error) {
        console.log(error);
      }
    },

    async cambiarEstado(item) {
      let value = item.id_estado === "2" ? 1 : 2;
      let data = {
        id_estado: value
      };
      try {
        await this.$service.graphql({
          query: `
            mutation edit($id: ID!, $usuario: EditUsuario!) {
              usuarioEdit(id: $id, usuario: $usuario) {
                id
              }
            }
          `,
          variables: {
            id: item.id,
            usuario: data
          }
        });
        if (value === 1) {
          this.$message.success("Usuario habilitado");
        } else {
          this.$message.warning("Usuario deshabilitado");
        }
        this.listarUsuarios();
      } catch (error) {
        console.log(error);
      }
    },
    // ----------------------------------------------------
    // Filtros
    // -----------------------------------------------------
    customFilter(items, filters, filter, headers) {
      // Init the filter class.
      const cf = new this.$MultiFilters(items, filters, filter, headers);
      cf.registerFilter("nombre_usuario", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          if (item.nombre_usuario != null) {
            return item.nombre_usuario
              .toLowerCase()
              .includes(searchWord.toLowerCase());
          } else {
            return "".toLowerCase().includes(searchWord.toLowerCase());
          }
        }, searchWord);
      });
      cf.registerFilter("nombre_completo", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          if (item.nombre_completo != null) {
            return item.nombre_completo
              .toLowerCase()
              .includes(searchWord.toLowerCase());
          } else {
            return "".toLowerCase().includes(searchWord.toLowerCase());
          }
        }, searchWord);
      });
      cf.registerFilter("correo", function(searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter(item => {
          if (item.correo != null) {
            return item.correo.toLowerCase().includes(searchWord.toLowerCase());
          } else {
            return "".toLowerCase().includes(searchWord.toLowerCase());
          }
        }, searchWord);
      });
      return cf.runFilters();
    },
    filterUsuario(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        nombre_usuario: val
      });
    },
    filterNombreCompleto(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        nombre_completo: val
      });
    },
    filterCorreo(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        correo: val
      });
    }

    // -----------------------------------------------------
  }
};
</script>

<style lang="scss">
.btn-refresh {
  min-width: 52px;

  .v-btn__content {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/usuario/Usuario.vue